import styled from "styled-components";
import DatePicker from "react-date-picker";
import { Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";

export const Container = styled.div`
  background-color: white;
  border-radius: 10px;
  width: auto;
  padding: 18px 25px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: "Mangueira Bold";
`;

export const CloseIcon = styled.span`
  font-size: 22px;
  color: ${({ theme }) => theme.colors.blue};
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Separator = styled.div`
  width: 100%;
  border-top: 1px dashed ${({ theme }) => theme.colors.lightGray};
  margin-top: 26px;
  margin-bottom: 17px;
`;

export const StatusContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StatusRadial = styled.input`
`;

export const StatusText = styled.span`
  color: #B4B4B4;
  font-size: 12px;
  line-height: 20px;
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 18px;
  display: block;
  margin-bottom: 15px;
`;

export const PeriodContainer = styled.div`
  height: auto;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 8px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const PeriodItem = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 14px;
  border-radius: 3px;
  background-color: transparent;
  border: 1px ${props => (props.selected ? `dashed ${props.theme.colors.blue}` : "solid #C1C1C1")};
  cursor: pointer;
  transition: 0.1s;
  color: ${props => (props.selected ? props.theme.colors.blue : "#C1C1C1")};

  &:hover {
    opacity: 0.9;
  }
`;

export const PeriodCircle = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background-color: ${props => (props.selected ? props.theme.colors.blue : "#C1C1C1")} !important;
  margin-right: 6px;
`;

export const PeriodText = styled.span`
  font-size: 12px;
  text-align: center;
`;

export const DateContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const DateItem = styled.div`
  width: 270px;

  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const CalendarIcon = styled.span`
  color: #C1C1C1;
  font-size: 20px;
  cursor: pointer;
`;

export const FilterButtonContainer = styled.button`
  width: 100%;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  border-radius: 5px;
  transition: 0.3s;
  border: 0px;
  color: white;

  &:hover {
    opacity: 70%;
  }
`;

export const CancelButtonContainer = styled.button`
  width: 100%;
  padding: 14px;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.blue};
  border-radius: 5px;
  transition: 0.3s;
  color: ${({ theme }) => theme.colors.blue};

  &:hover {
    opacity: 70%;
  }
`;

export const FilterButtonText = styled.span`
  font-size: 15px;
  font-weight: bold;
`;

export const StatusItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    cursor: pointer;
  }
`;
